const getFilterData = state  => state.filterData;
const isFilterLoading = state  => state.isFilterLoading;

const getUtilizationList = state  => state.utilizationList;
const isUsageListLoading = state => state.isUsageListLoading;

const getTotalSummary = state  => state.totalSummary;
const isTotalSummaryLoading = state => state.isTotalSummaryLoading;

const getTransition = state  => state.transition;
const isTransitionLoading = state => state.isTransitionLoading;

export default {
  getFilterData,
  isFilterLoading,
  getUtilizationList,
  isUsageListLoading,
  getTotalSummary,
  isTotalSummaryLoading,
  getTransition,
  isTransitionLoading
};



// WEBPACK FOOTER //
// ./src/store/modules/savings-plans/utilization/getters.js